/**
 * * Resposta paginada do servidor.
 */
export class PageableResponse<T> {

  constructor(
    /**
     * * Lista com o conteúdo paginado.
     */
    public content: T[],
    /**
     * * Total de páginas.
     */
    public totalPages: number,
    /**
     * * Total de itens
     */
    public totalElements: number
  ) {}

}
